export default {
  'menu.welcome': 'Welcome',
  'menu.login': 'Đăng nhập',
  'menu.blog': 'Blog',
  'menu.blog.authors': 'Tác giả',
  'menu.blog.authors_create': 'Tạo mới tác giả',
  'menu.blog.authors_edit': 'Cập nhật tác giả',
  'menu.blog.topics': 'Chủ đề',
  'menu.blog.topics_create': 'Tạo mới chủ đề',
  'menu.blog.topics_edit': 'Cập nhật chủ đề',
  'menu.blog.articles': 'Bài viết',
  'menu.blog.articles_create': 'Tạo mới bài viết',
  'menu.blog.articles_edit': 'Cập nhật bài viết',
  'menu.news': 'Tin tức',
  'menu.zodiac': 'Cung hoàng đạo',
  'menu.zodiac.list': 'Danh sách',
  'menu.new_create': 'Tạo mới tin tức',
  'menu.new_edit': 'Cập nhật tin tức',
  'menu.music': 'Âm nhạc',
  'menu.music_create': 'Tạo mới âm nhạc',
  'menu.music_edit': 'Cập nhật âm nhạc',
  'menu.prayer': 'Văn khấn',
  'menu.prayer.category-list': 'Danh mục',
  'menu.prayer.category-create': 'Tạo mới danh mục',
  'menu.prayer.category-update': 'Cập nhật danh mục',
  'menu.prayer.prayer-list': 'Danh sách',
  'menu.prayer.prayer-create': 'Tạo mới văn khấn',
  'menu.prayer.prayer-update': 'Cập nhật văn khấn',

  'menu.quote': 'Danh ngôn',
  'menu.quote.list': 'Danh sách',
  'menu.quote_create': 'Tạo mới danh ngôn',
  'menu.quote_edit': 'Cập nhật danh ngôn',
  'menu.zodiac.create': 'Tạo mới cung hoàng đạo',
  'menu.zodiac.edit': 'Cập nhật cung hoàng đạo',
  'menu.zodiac.list-celebrity': 'Người nổi tiếng',
  'menu.zodiac.create-celebrity': 'Tạo mới người nổi tiếng',
  'menu.zodiac.edit-celebrity': 'Cập nhật người nổi tiếng',
  'menu.numerology.list': 'Danh sách',
  'menu.numerology': 'Thần số học',
  'menu.numerology.create': 'Tạo mới thần số học',
  'menu.numerology.edit': 'Cập nhật thần số học',
  'menu.package': 'Package IAP',
  'menu.package.list': 'Danh sách',
  'menu.package.create': 'Tạo mới',
  'menu.package.edit': 'Cập nhật',
  'menu.numerology.list-celebrity': 'Người nổi tiếng',
  'menu.numerology.create-celebrity': 'Tạo mới người nổi tiếng',
  'menu.numerology.edit-celebrity': 'Cập nhật người nổi tiếng',
  'menu.zodiac.list-horoscopes': 'Giải nghĩa',
  'menu.numerology.list-relations': 'Mối quan hệ',
  'menu.users': 'Người dùng',
  'menu.package.list-iap': 'Gói',
  'menu.package.list-receipt': 'Giao dịch',
  'menu.tarot': 'Tarot',
  'menu.tarot.list-card': 'Thẻ Tarot',
  'menu.tarot.list-topic': 'Chủ đề',
  'menu.tarot.list-question': 'Câu hỏi',
  'menu.tarot.list-tarot': 'Giải nghĩa',
  'menu.notifications': 'Thông báo',
  'menu.notifications_create': 'Tạo thông báo',
  'menu.package.create-iap': 'Tạo mới iap',
  'menu.package.edit-iap': 'Cập nhật iap',
  'menu.zodiac.create-horoscopes': 'Tạo mới giải nghĩa',
  'menu.zodiac.edit-horoscopes': 'Cập nhật giải nghĩa',
  'menu.numerology.create-relations': 'Tạo mới mối quan hệ',
  'menu.numerology.edit-relations': 'Cập nhật mối quan hệ',
  'menu.tarot.edit-card': 'Cập nhật thẻ Tarot',
  'menu.tarot.edit-tarot': 'Cập nhật giải nghĩa',
  'menu.system': 'Hệ thống',
  'menu.system.administrator': 'Quản trị viên',
  'menu.system.member-list': 'Danh sách thành viên',
  'menu.system.permission': 'Phân quyền',
  'menu.system.permission_create': 'Tạo mới phân quyền',
  'menu.system.permission_update': 'Cập nhật phân quyền',
  'menu.system.administrator.list': 'Danh sách',
  'menu.system.administrator.create': 'Tạo mới',
  'menu.system.administrator.edit': 'Cập nhật',
  'menu.banner': 'Banner',
  'menu.banner_create': 'Tạo mới banner',
  'permission.create.success': 'Tạo mới quyền quản trị thành công!',
  'permission.update.success': 'Chỉnh sửa quyền quản trị thành công!',
  'menu.banner_edit': 'Cập nhật banner',
};
